import { NameWrappedAction, EventReducerNames, AppReducer } from 'store/types';
import { createNamedWrapperReducer } from 'store/services';

export function createEventReducer<S, A extends NameWrappedAction>(
  reducerFunction: AppReducer<S, A>,
  reducerName: EventReducerNames,
) {
  return createNamedWrapperReducer<S, A>(reducerFunction, reducerName);
}
